<mat-card class="cardWithShadow dashboard-card">
  <mat-card-content class="dashboard-card-content">
    <mat-card-title class="dashboard-card-title">
      {{ 'dashboard.store_provider_report' | translate }}
    </mat-card-title>

    <div class="dashboard-store-provider-grid">
      <app-treeslo-grid #storeProviderReportGrid [config]="gridConfig"
        (columnOrderChange)="onStoreProviderReportGridColumnOrderChange($event)">
        <ng-template appTableColumnTemplate="provider" let-row>
          @if (row.provider) {
            @if (isAmazonProvider(row.provider)) {
              <span class="provider-logo-wrap" [matTooltip]="getProviderName(row.provider)">
                <img
                  class="provider-logo provider-logo--light"
                  src="assets/images/providers-logos/amazon.png"
                  [alt]="getProviderName(row.provider)" />
                <img
                  class="provider-logo provider-logo--dark"
                  src="assets/images/providers-logos/amazon-white.png"
                  [alt]="getProviderName(row.provider)" />
              </span>
            } @else {
              <img
                class="provider-logo"
                [src]="getProviderLogo(row.provider)"
                [alt]="getProviderName(row.provider)"
                [matTooltip]="getProviderName(row.provider)" />
            }
          } @else {
            ---
          }
        </ng-template>

        <ng-template appTableResponsiveCardTemplate let-row>
          <app-store-provider-report-responsive-card
            [row]="row"
            [providers]="providers()" />
        </ng-template>
      </app-treeslo-grid>
    </div>
  </mat-card-content>
</mat-card>
